
import {
    DetailsListLayoutMode, IColumn, IContextualMenuItem, Selection, SelectionMode
} from '@fluentui/react';
import { RootState } from 'app/store';
import CollapsiblePanel from "components/controls/CustomPanel";
import { addUpdateNonStandards, addUpdateNonStandardTemplates } from 'global/Reducer/dataSlice';
import { copyPropertiesOnly, timestamp } from 'global/Utility/TSFunctions';
import * as IXrmTypes from 'model/CRM';
import * as FAM from 'model/FlexibleAttributeModel';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { createNonStandard, createNonStandardColumns, createNonStandardTemplate, DetailListExcelGenerationAsync, emitCustomEvent, EViewType, fadeIn } from "../../global/Application";
import NonStandardEditor from './NonStandardEditor';
import NonStandardWizard from './NonStandardWizard';

import { RouterParams } from 'App';
import CustomDetailList from 'components/controls/CustomDetailList';
import { DefaultGridConfig } from 'components/controls/CustomDetailList/CustomDetailList';
import { ICustomDetailListConfiguration } from 'components/controls/CustomDetailList/ICustomDetailListConfiguration';
import { IGridItem } from 'components/controls/CustomDetailList/IGridItem';
import { useApplication } from 'global/Application/Context';
import { setProcessing, updateCustomDetailListConfiguration } from 'global/Reducer/statusSlice';

import { useHistory, useParams } from 'react-router-dom';
import NonStandardTemplateWizard from './NonStandardTemplateWizard';
import { ConfirmationDialog } from '../../components/controls/ConfirmationDialog';
import saveAs from 'file-saver';
import { TSearchPredicateAsync } from '../../components/controls/LookupControlDialog';
import NonStandardApplyTemplate from './NonStandardApplyTemplate';

interface IProps extends TComponentConnectedProps {
    groupConfiguration?: FAM.IGroupConfigurationData;
    benefit?: FAM.IBenefit;
    section: IXrmTypes.bcbs_config_section;
    disabled?: boolean;
    nonStandards?: FAM.INonStandard[];
    variant?: 'importer' | 'default';
    tierNames: Record<string, FAM.ITierLevel>
}


const gridStyles = {
    root: {
        marginBottom: '1.45em',
        marginTop: '6px',
    },
    headerWrapper: {
        selectors: {
            '.ms-DetailsHeader': {
                paddingTop: '0px',
            },
        }
    }
};

type TNonstandardGridItem = IGridItem<FAM.INonStandard>;

const NonStandardGridView = (props: IProps) => {

    const dispatch = useDispatch();
    const application = useApplication();
    const history = useHistory();
    const [nonStandard, setNonStandard] = useState<FAM.INonStandard | null>(null);

    const [nonStandardEditorIsMounted, setNonStandardEditorIsMounted] = useState(false);
    const [nonStandardEditorIsOpen, _setNonStandardEditorIsOpen] = useState(false);
    const setNonStandardEditorIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!nonStandardEditorIsMounted)
            setNonStandardEditorIsMounted(true);
        _setNonStandardEditorIsOpen(value);
    }

    const [selectionCount, setSelectionCount] = useState(0);
    const [selectedItems, setSelectedItems] = useState<FAM.INonStandard[] | null>(null);

    const [applyTemplateIsMounted, setApplyTemplateIsMounted] = useState(false);
    const [applyTemplateIsOpen, _setApplyTemplateIsOpen] = useState(false);
    const setApplyTemplateIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!applyTemplateIsMounted)
            setApplyTemplateIsMounted(true);
        _setApplyTemplateIsOpen(value);
    }

    const [nonStandardWizardIsMounted, setNonStandardWizardIsMounted] = useState(false);
    const [nonStandardWizardIsOpen, _setNonStandardWizardIsOpen] = useState(false);
    const setNonStandardWizardIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!nonStandardWizardIsMounted)
            setNonStandardWizardIsMounted(true);
        _setNonStandardWizardIsOpen(value);
    }

    const [_nonStandardTemplate, setNonStandardTemplate] = useState<FAM.INonStandardTemplate | null>(null);
    const [nonStandardTemplateWizardIsMounted, setNonStandardTemplateWizardIsMounted] = useState(false);
    const [nonStandardTemplateWizardIsOpen, _setNonStandardTemplateWizardIsOpen] = useState(false);
    const setNonStandardTemplateWizardIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!nonStandardTemplateWizardIsMounted)
            setNonStandardTemplateWizardIsMounted(true);
        _setNonStandardTemplateWizardIsOpen(value);
    }

    const [alertIsMounted, setAlertIsMounted] = useState(false);
    const [alertIsOpen, _setAlertIsOpen] = useState(false);
    const setAlertIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!alertIsMounted)
            setAlertIsMounted(true);
        _setAlertIsOpen(value);
    }
    //CREATE A NEW ON OPEN METHOD OR ON ADD AND ADD THAT VIEW TO THE WIZARD THEN BACK HERE INVOKE THE TEMPLATE WIZARD DUHHHHHH

    const params = useParams<RouterParams>()

    const categoryGroupConfiguration = props.state.data.config.cache.map_bcbs_config_category_named['Group Configuration'];
    const categoryNonStandardTemplate = props.state.data.config.cache.map_bcbs_config_category_named['Non-Standard Template'];


    let disabled = props.disabled;

    const disableAddingNonstandardByChangeType =
        (props.benefit && !application.ChangeTypePermissions.canAddBenefitNonstandard) ||
        (props.groupConfiguration && !application.ChangeTypePermissions.canAddGroupConfigurationNonstandard);

    // if not disabled and for benefit but can not add nonstandard to benefit
    if (!disabled && disableAddingNonstandardByChangeType)
        disabled = true;

    // if not disabled and for group configuration but can not add nonstandard to group configuration
    if (!disabled && disableAddingNonstandardByChangeType)
        disabled = true;

    const storageId = `nonstandard.grid(${props.section.bcbs_config_sectionid})`;

    const scopeGridConfig = () => {
        const u = props.state.status.gridConfigs[storageId];
        if (u)
            return u;

        const t = DefaultGridConfig();
        t.sort = [{ column: { key: 'nonStandardName' }, isSortedDescending: false }];

        return t;
    }

    const [gridConfig, setGridConfig] = useState<ICustomDetailListConfiguration>(scopeGridConfig());
    const gridConfigRef = useRef(gridConfig);

    // check if it has changed since mounting
    if (gridConfig !== gridConfigRef.current) {
        // console.log("render:grid config updated", gridConfig);

        gridConfigRef.current = gridConfig;

        // snapshot for bind back
        dispatch(updateCustomDetailListConfiguration({ id: storageId, gridConfig: structuredClone(gridConfig) }));
    }

    const onColumnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => {
        setGridConfig(t => {

            const gridConfig: ICustomDetailListConfiguration = { ...t };

            gridConfig.sort = [{
                column: { key: column.key },
                isSortedDescending: !t?.sort?.[0]?.isSortedDescending ?? false,
            }];


            return gridConfig;
        });
    };



    let scopeNonStandards: FAM.INonStandard[] = [];

    if (props.groupConfiguration)
        scopeNonStandards = props.groupConfiguration.nonStandards;

    if (props.benefit)
        scopeNonStandards = props.benefit.nonStandards;

    // externally supplied non standards?
    if (props.nonStandards)
        scopeNonStandards = props.nonStandards


    useEffect(() => {
        if (history.location.search === '?navigation=pending')
            if (params.nonStandardId)
                setTimeout(() => {
                    const nonstandard = scopeNonStandards.find(t => t.id === params.nonStandardId);
                    if (nonstandard) {
                        const section = props.state.data.config.cache.map_bcbs_config_section[nonstandard?.sectionRef?.id!];
                        const tab = props.state.data.config.cache.map_bcbs_config_tab[section._bcbs_config_tabid_value!];
                        if (section.bcbs_config_sectionid === props.section.bcbs_config_sectionid) {
                            onSelect([nonstandard]);

                            if (!params.field2ndId && !params.tab2ndId && !params.section2ndId)
                                history.push({ pathname: history.location.pathname, search: '?navigation=complete' });
                        }
                    }
                }, 200);
    }, []);

    const columns = useMemo(() => {

        // nonstandard must be defined for a section
        if (!props.section)
            return [];

        // generating a temporary non-standard to match the schema
        const columns = createNonStandardColumns(
            props.state.data.config,
            {
                section: props.section,
                benefit: props.benefit,
                tierNames: props.tierNames ?? []
            },
            gridConfig,
            onColumnClick
        );

        return columns;

    }, [gridConfig.filter, gridConfig.sort]);

    const [items, itemsPaged] = useMemo(() => {

        const items: TNonstandardGridItem[] = [];

        const gridConfigMappedColumns = {
            filterColumns: gridConfig.filter.map(q => columns?.find(w => w.key === q.column.key)),
            sortColumns: gridConfig.sort.map(q => columns?.find(w => w.key === q.column.key)),
        }

        scopeNonStandards.forEach((eNonStandard, index) => {

            // skip deactivated records/only show deactivated records if permitted at group config properties level (xnor)
            if (eNonStandard.deactivated !== props.state.data.json.showInActives?.value)
                return;

            // skip non-standards that are not for my section
            if (props.section)
                if (eNonStandard.sectionRef?.id !== props.section.bcbs_config_sectionid)
                    return;

            const item: TNonstandardGridItem = {
                key: eNonStandard.id,
                name: eNonStandard.name,
                _index: index,
                data: eNonStandard
            };

            eNonStandard.fields.forEach(eachField => {
                const configAttributeId = eachField.configRef.id;
                // lets always get the first one
                // verified with William there will never be a Tier/PCP/Specialist mode for these.
                eachField.values.forEach(eachFieldValue => {
                    const key = `${configAttributeId}-${eachFieldValue?.tierRef?.id ?? ''}`;
                    item[key] = eachFieldValue.value;
                });
            });

            // Filtering :
            let include = true;
            if (gridConfig && gridConfig.filter && gridConfig.filter.length > 0) {
                gridConfig.filter.forEach((filter, ix) => {
                    const column = gridConfigMappedColumns.filterColumns[ix];
                    if (column) {
                        const predicate = column.filterPredicate;
                        if (predicate)
                            include = include && predicate(item, filter.value, column);
                    }
                });
            }

            if (include)
                items.push(item);
        });


        if (gridConfig && gridConfig.sort && gridConfig.sort.length > 0)
            items.sort((a, b) => {

                let ret = 0;

                gridConfig.sort?.forEach((sort, ix) => {
                    const column = gridConfigMappedColumns.sortColumns[ix];

                    // TODO why was this needed?
                    if (!column)
                        return;

                    const predicate = column.sortPredicate;
                    const isSortedDescending = sort.isSortedDescending ?? false;

                    if (predicate)
                        ret = ret || isSortedDescending
                            ? predicate(a, b, undefined, column) * -1
                            : predicate(a, b, undefined, column);
                });

                return ret;

            });


        const itemsPaged = items.slice((gridConfig.page - 1) * gridConfig.pageSize, gridConfig.page * gridConfig.pageSize);

        return [items, itemsPaged];
        // return items;
    },
        [
            props.groupConfiguration?.nonStandards,
            props.benefit?.nonStandards,
            props.nonStandards,
            props.state?.data?.json?.showInActives?.value,
            gridConfig.filter,
            gridConfig.sort,
            gridConfig.page,
        ]
    );

    const selection = useRef(new Selection({
        onSelectionChanged: () => {

            const selectionCount = selection.current.getSelectedCount();
            setSelectionCount(selectionCount);

        },
        selectionMode: SelectionMode.multiple,
    }))

    const menu: IContextualMenuItem[] = [];
    if (!disabled && props.state.status.viewType === EViewType.Modify)
        menu.push({
            key: 'nonstandard.manage',
            name: 'Manage',
            icon: 'DocumentManagement',
            onClick: (event, item) => {
                if (event?.stopPropagation)
                    event.stopPropagation();

                let selectedItems = selection.current.getSelection() as TNonstandardGridItem[];

                if (selection.current.isAllSelected())
                    selectedItems = items;

                onSelect(selectedItems.map(q => q.data!));
                setNonStandardWizardIsOpen(true);
            },
        });

    if (!disabled)
        if (selectionCount > 0)
            menu.push({
                key: `nonStandard.Edit`,
                name: 'Edit',
                icon: 'PageEdit',
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    let selectedItems = selection.current.getSelection() as TNonstandardGridItem[];

                    if (selection.current.isAllSelected())
                        selectedItems = items;

                    onSelect(selectedItems.map(q => q.data!));
                }
            });

    if (disabled)
        if (selectionCount === 1)
            menu.push({
                key: `nonStandard.View`,
                name: 'View',
                icon: 'Page',
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    const selectedItems = selection.current.getSelection() as TNonstandardGridItem[];

                    onSelect(selectedItems.map(q => q.data!));
                }
            });

    const onSelect = (selectedItems: FAM.INonStandard[]) => {
        if (!props.section)
            throw new Error('section has not been identified.');

        if (selectedItems && selectedItems.length === 1) {
            const _t = selectedItems[0];

            setNonStandard(structuredClone(_t));

            setNonStandardEditorIsOpen(true);

        } else if (selectedItems && selectedItems.length > 1) {

            setSelectedItems(selectedItems);

            const _t = createNonStandard(props.state.data, {
                section: props.section,
                benefit: props.benefit,
                groupConfiguration: props.groupConfiguration
            });
            _t.id = 'bulk';

            setNonStandard(_t);
            setNonStandardEditorIsOpen(true);
        }
    }

    const onRenderGrid = () => {
        return <CustomDetailList
            items={items}
            itemsPaged={itemsPaged}
            columns={columns}
            quickSearchColumnKey={'nonStandardName'}
            selectionMode={SelectionMode.multiple}
            styles={gridStyles}
            layoutMode={DetailsListLayoutMode.fixedColumns}
            selection={selection.current}
            onShouldVirtualize={() => false}
            getKey={(item) => { return item.key }}
            onExtract={() => { DetailListExcelGenerationAsync(dispatch, props.state, application, columns, items) }}
            onItemInvoked={(item: TNonstandardGridItem, index, event) => {

                // on double click of main component nothing to do
                if (props.variant === "importer")
                    return;

                if (item.data)
                    onSelect([item.data]);
            }}
            gridConfig={[gridConfig, setGridConfig]}
        />;
    }

    const onRenderEditor = () => {
        if (!nonStandardEditorIsMounted)
            return <></>;

        const costshareCategory = props.benefit ?? categoryGroupConfiguration;

        return <NonStandardEditor
            isOpen={nonStandardEditorIsOpen}
            onDismiss={() => { setNonStandardEditorIsOpen(false); }}
            defaultValue={nonStandard ?? null}
            costshareCategory={costshareCategory}
            benefit={props.benefit}
            disabled={disabled}
            onChange={(nonStandard, changeTracker) => {
                let dispatchNonStandards = [nonStandard];

                if (nonStandard.id === 'bulk') {

                    if (!selectedItems)
                        return;

                    const selectedItemsCloned = structuredClone(selectedItems);

                    selectedItemsCloned.forEach(eClone => {
                        eClone.fields.forEach(eCloneField => {
                            const matchingField = nonStandard.fields.find(q => q.configRef.id === eCloneField.configRef.id);
                            if (matchingField) {
                                eCloneField.values.forEach(eCloneFieldValue => {
                                    // tier refs should exactly match since they are both originated from same source tier levels
                                    const matchingFieldValue = matchingField.values.find(q => q.type === eCloneFieldValue.type && q.tierRef?.name === eCloneFieldValue.tierRef?.name)
                                    if (matchingFieldValue?.value)
                                        eCloneFieldValue.value = matchingFieldValue.value;
                                });
                            }
                        });

                        copyPropertiesOnly(nonStandard,
                            eClone,
                            ['deactivated', 'referenceOnly'],
                            false,
                            (key, source) => {
                                if (source[key] === undefined)
                                    return false;

                                return true;
                            }
                        );

                    });

                    dispatchNonStandards = selectedItemsCloned;
                }
                debugger;
                dispatch(
                    addUpdateNonStandards([
                        {
                            config: props.state.data.config,
                            nonStandards: dispatchNonStandards,
                            groupConfiguration: props.groupConfiguration,
                            benefit: props.benefit,
                            changeTracker: changeTracker
                        }]
                    )
                );
                if (_nonStandardTemplate) {
                    //update the template name for when we are creating a new NS and wanting to template immediatly 
                    let nonStandardTemplate = structuredClone(_nonStandardTemplate);
                    var section = props.state.data.config.cache.map_bcbs_config_section[nonStandard!.sectionRef!.id];
                    let category = props.state.data.config.cache.map_bcbs_config_category[section!._bcbs_config_categoryid_value!];
                    nonStandardTemplate.name = nonStandard.name;

                    let nonStandardBenefitDefintion = nonStandard.fields.find(field => field.configRef.id === "ff72f3f2-d38d-ec11-b400-0022480a9a56");
                    let nonStandardPayAccordingToBenefit = nonStandard.fields.find(field => field.configRef.id === "fd72f3f2-d38d-ec11-b400-0022480a9a56");

                    let templateDefinitionField = nonStandardTemplate.fields.find(field => field.configRef.id === "1fe66c74-710c-ef11-9f89-6045bdeb64f8"); //template definition
                    templateDefinitionField!.values[0].value = structuredClone(nonStandardBenefitDefintion?.values[0].value!);

                    if (nonStandardPayAccordingToBenefit) {
                        let templatePayAccordingField = nonStandardTemplate.fields.find(field => field.configRef.id === "05beb613-720c-ef11-9f89-6045bdeb64f8"); //template pay according
                        templatePayAccordingField!.values[0].value = structuredClone(nonStandardPayAccordingToBenefit?.values[0].value!);
                    }

                    let categoryID = props.section!._bcbs_config_categoryid_value!;
                    nonStandardTemplate.linkedCategoryTypeId = categoryID;

                    //this is for creating a new template
                    console.log("benefit: " + props.benefit);
                    console.log("groupconfig: " + props.groupConfiguration);
                    //create new relationship 
                    if (props.section) {
                        let categoryId = props.benefit?.id ?? props.groupConfiguration?.id;
                        let sectionRef: FAM.ITemplateSectionRelationship =
                        {
                            sectionId: props.section.bcbs_config_sectionid ?? "",
                            nonstandards: [{
                                id: nonStandard?.id ?? "",
                                name: nonStandard?.name ?? "",
                            }],

                        };
                        nonStandardTemplate.relationships?.push(
                            {
                                categoryID: categoryId ?? "",
                                categoryType: category?.bcbs_name ?? "",
                                sectionRefs: [sectionRef],
                            });
                    }
                    let nsClone = structuredClone(nonStandard)
                    nsClone.partOfTemplate = true;
                    dispatch(addUpdateNonStandards([{
                        config: props.state.data.config,
                        nonStandards: [nsClone],
                        benefit: props.benefit,
                        groupConfiguration: props.groupConfiguration,
                        changeTracker: {}
                    }]));

                    dispatch(addUpdateNonStandardTemplates([{
                        nonStandardTemplates: [nonStandardTemplate],
                    }]));
                }
                setNonStandardEditorIsOpen(false);
                setSelectedItems(null);
            }}
        />

    }


    const onRenderWizard = () => {
        if (!nonStandardWizardIsMounted)
            return <></>;

        return <NonStandardWizard
            isOpen={nonStandardWizardIsOpen}
            onDismiss={() => setNonStandardWizardIsOpen(false)}
            onCancel={() => setNonStandardWizardIsOpen(false)}
            section={props.section}
            benefit={props.benefit}
            groupConfiguration={props.groupConfiguration}
            nonStandard={nonStandard ?? undefined}
            onAdd={() => {
                if (!props.section)
                    throw new Error('section has not been identified.');

                const nonStandard: FAM.INonStandard = createNonStandard(
                    props.state.data,
                    {
                        section: props.section,
                        benefit: props.benefit,
                        groupConfiguration: props.groupConfiguration
                    }
                );

                dispatch(addUpdateNonStandards([{
                    config: props.state.data.config,
                    nonStandards: [nonStandard],
                    benefit: props.benefit,
                    groupConfiguration: props.groupConfiguration,
                    changeTracker: {}
                }]));

                onSelect([nonStandard]);
            }}
            onAddTemplate={() => {
                setNonStandardWizardIsOpen(false);
                if (selectionCount <= 1) {
                    const selectedItems = selection.current.getSelection() as TNonstandardGridItem[];

                    onSelect(selectedItems.map(q => q.data!));
                    setNonStandardTemplateWizardIsOpen(true);
                }
                else {
                    setAlertIsOpen(true);
                }

            }}
            onCreateNsAndTemplate={() => {
                const nonStandard: FAM.INonStandard = createNonStandard(
                    props.state.data,
                    {
                        section: props.section,
                        benefit: props.benefit,
                        groupConfiguration: props.groupConfiguration,
                        //templated: true
                    }
                );

                dispatch(addUpdateNonStandards([{
                    config: props.state.data.config,
                    nonStandards: [nonStandard],
                    benefit: props.benefit,
                    groupConfiguration: props.groupConfiguration,
                    changeTracker: {}
                }]));

                var section = props.state.data.config.cache.map_bcbs_config_section[nonStandard!.sectionRef!.id];
                let category = props.state.data.config.cache.map_bcbs_config_category[section!._bcbs_config_categoryid_value!];

                const nonStandardTemplate: FAM.INonStandardTemplate = createNonStandardTemplate(
                    props.state.data,
                    {
                        id: nonStandard.id,
                        name: nonStandard.name,
                        category: categoryNonStandardTemplate,
                        linkedCategory: category,
                        linkedCategoryName: category.bcbs_name ?? null,
                    }
                )

                setNonStandardTemplate(nonStandardTemplate);
                dispatch(addUpdateNonStandardTemplates([{
                    nonStandardTemplates: [nonStandardTemplate],
                }]));

                onSelect([nonStandard]);
            }}
            onCreateNsAndLinkTemplate={() => {
                setApplyTemplateIsOpen(true);
            }}
        />;
    }

    const onRenderApplyTemplate = () => {
        if (!applyTemplateIsMounted)
            return <></>;


        return <NonStandardApplyTemplate
            isOpen={applyTemplateIsOpen}
            onDismiss={() => { setApplyTemplateIsOpen(false); setApplyTemplateIsMounted(false) }}
            benefit={props.benefit}
            sectionForNS={props.section}
            groupConfiguration={props.groupConfiguration}
            isNewNSAndChooseTemplate={true}
        />
    }


    function onRenderAlert(): JSX.Element {
        if (!alertIsMounted)
            return <></>;

        return <ConfirmationDialog
            onClose={() => { setAlertIsOpen(false); setAlertIsMounted(false); }}
            onContinue={() => { setAlertIsOpen(false); setAlertIsMounted(false); }}
            continueText="Continue"
            cancelText="Cancel"
        >
            <p>Only one Non-Standard may be selected for templating from this screen</p>
        </ConfirmationDialog>;
    }

    const onRenderTemplateWizard = () => {
        if (!nonStandardTemplateWizardIsMounted)
            return <></>;

        return <div>
            <NonStandardTemplateWizard
                isOpen={nonStandardTemplateWizardIsOpen}
                onCancel={() => setNonStandardTemplateWizardIsOpen(false)}
                onDismiss={() => setNonStandardTemplateWizardIsOpen(false)}
                benefit={props.benefit}
                groupConfiguration={props.groupConfiguration}
                nonStandard={nonStandard ?? undefined}
            />
        </div>
    }

    const onRender = () => {
        return <div>
            {onRenderApplyTemplate()}
            {onRenderAlert()}
            {onRenderEditor()}
            {onRenderWizard()}
            {onRenderTemplateWizard()}

            <CollapsiblePanel
                title={`Non-Standards (${items.length})`}
                id={`nonStandard.${props.section.bcbs_config_sectionid}`}
                canCollapse={true}
                defaultCollapsed={(props.state.status.userConfigs['defaults.nonstandards.defaultCollapsed'] as boolean) ?? items?.length < 1 ?? true}
                mountWhenExpanded={true}
                storageId={`nonStandard(${props.section?.bcbs_config_sectionid})`}
                items={menu}
            >
                {onRenderGrid()}
            </CollapsiblePanel>
        </div>
    }

    if (props.variant === 'importer')
        return onRenderGrid();

    return onRender();
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(NonStandardGridView);
